export default __webpack_public_path__ + "static/media/img--bathroom-dark.2de9ff79.jpg";